import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-matrixsingle',
  templateUrl: './matrixsingle.html',
  styleUrls: ['./matrixsingle.scss']
})

export class MatrixSingle implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;
  public answers = [];
  public headers = [];
  public rows = [];

  private loadMSAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    if(dataSvc != null && dataSvc !== undefined){    
      var exisitingLangauge = localStorage.getItem("userslanguage");
      if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
        this.dataSvc.changeLangauge(exisitingLangauge);
      }
      else{
        this.translate.setDefaultLang("en");
        this.translate.use("en");
      }
    }

    this.loadMSAnswersSubscription = this.dataSvc.getLoadMatrixSingleAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.answers = [];
    this.headers = [];
    this.rows = [];
  }

  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 14) return;

    var currentQuestion = this.dataSvc.currentQuestion();
    var response = currentQuestion.QuestionResponses[0].Response;
    if(response !== null && response !== undefined){
      this.rows = response.AnswerText.split(",");
      this.headers = response.QuestionText.split(",");
    }

    setTimeout(() => {
      var responseText = currentQuestion.Result.Selection;
      if(responseText !== null && responseText !== undefined && responseText !== ""){
        var rt = responseText.split(",");
        if(rt.length > 0){
          for(var r = 0; r < rt.length; r++){
            var inputs = document.getElementsByClassName("matrixSingleInput");
            var answer = rt[r].split("||");
            if(answer.length == 2){
              for (var i = 0; i < inputs.length; i++) {
                var element = (<HTMLInputElement>inputs[i]);
                var row = parseInt(element.getAttribute("data-rowindex"));
                var header = parseInt(element.getAttribute("data-headerindex"));
  
                if(answer[0] == "tbMatrixSingleInput" + (row + 1) +"Column" + (header + 1)){
                  element.value = answer[1];
                }
              }
            }
          }
        }
      }
    },100);
  }

  updateAnswers(){
    this.answers.length = 0;
    var inputs = document.getElementsByClassName("matrixSingleInput");
    for (var i = 0; i < inputs.length; i++) {
      var element = (<HTMLInputElement>inputs[i]);        
      var input = element.value;
      var row = parseInt(element.getAttribute("data-rowindex"));
      var header = parseInt(element.getAttribute("data-headerindex"));

      var answer = "tbMatrixSingleInput" + (row + 1) +"Column" + (header + 1) + "||" + input;
      this.answers.push(answer);
    } 
    this.dataSvc.currentQuestion().Result.Selection = this.answers.join(",");
  }


  

 
}
